<template>
    <div class="relative h-44 lg:h-full min-h-[200px] lg:max-h-80 overflow-hidden rounded-xl"
         :class="learning ? 'flex-1' : ''">
        <img class="absolute inset-0 h-full w-full object-cover" :src="content.image" :title="content.name"/>
    </div>
</template>

<script setup>
    import { defineProps } from 'vue';

    const props = defineProps({
        content: Object,
        learning: Boolean
    });
</script>
